import { useEffect, useState } from "react";
import { api } from "@/lib/trpc";

/** Ниже трёх знаков проверять нечего — схема всё равно отклонит. */
const MIN_LENGTH = 3;
/** Пауза набора, после которой имеет смысл спрашивать сервер. */
const DEBOUNCE_MS = 400;

/**
 * Проверка занятости ника на лету (шаг 1 мастера).
 *
 * Дебаунс обязателен: без него каждый символ уходит отдельным запросом,
 * и последний ответ приходит не последним — поле начинает мигать «занят /
 * свободен». Запрос кешируется по значению, поэтому возврат к уже
 * проверенному нику ответа не ждёт.
 */
export function useNicknameCheck(value: string) {
	const normalized = value.trim().toLowerCase();
	const [debounced, setDebounced] = useState(normalized);

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(normalized), DEBOUNCE_MS);
		return () => clearTimeout(timer);
	}, [normalized]);

	const enabled = debounced.length >= MIN_LENGTH;
	const query = api.profile.checkNickname.useQuery(
		{ nickname: debounced },
		{ enabled, staleTime: 30_000, retry: false },
	);

	return {
		/** true — набор ещё не устоялся либо ответ в пути. */
		pending: enabled && (query.isPending || debounced !== normalized),
		result: debounced === normalized ? query.data : undefined,
		enabled,
	};
}
